import axios, { AxiosRequestConfig } from 'axios';
import { AXIOS_TIMEOUT } from '@/config';

export const headers: Record<string, string> = {
  'ngrok-skip-browser-warning': 'true',
};

export const axiosConfig: AxiosRequestConfig = {
  timeout: AXIOS_TIMEOUT,
  headers,
};

export const fetchRetry = async (
  url: RequestInfo | URL,
  options: RequestInit & {
    retry?: number;
    timeout?: number;
    callback?: (retry: number) => void;
  } = {},
) => {
  let retry = options.retry ?? 3;
  const { callback, timeout = 30000, ...init } = options;
  init.signal = AbortSignal.timeout(timeout);

  while (retry > 0) {
    try {
      return await fetch(url, init);
    } catch (e) {
      callback?.(retry);
      retry--;
      if (retry === 0) throw e;
    }
  }
};
